// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Radio_wrap__al4a2","icon":"Radio_icon__8x545","active":"Radio_active__sC88o","default":"Radio_default__DUtUZ","input":"Radio_input__fudjR","label":"Radio_label__oeKOD"};